<template>
	<v-dialog
    v-model="reporteFechas.status"
    hide-overlay
    persistent
    max-width="1000"
  >
    <v-card>
      <v-card-title primary-title class="text-subtitle-1">
        Reporte por rango de fechas
      </v-card-title>
      <v-card-text>

      	<v-row>
      		<v-col cols="12" md="6" lg="4">
		        <v-text-field
		          v-model="fechaini"
		          dense
		          filled
		          type="date"
		          label="Fecha inicio"
		          clearable
              hide-details
		        ></v-text-field>
      		</v-col>

      		<v-col cols="12" md="6" lg="4">
		        <v-text-field
		          v-model="fechafin"
		          dense
		          filled
		          type="date"
		          label="Fecha final"
		          clearable
              hide-details
		        ></v-text-field>
      		</v-col>
      		<v-col cols="12" md="6" lg="4">
      			<v-btn
              color="orange"
              dark
              @click="initialize"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
      		</v-col>
      	</v-row>

        <v-data-table
          :headers="headersCerrados"
          :items="reporte"
          class="elevation-0 mt-4"
          dense
          :search="search"
          item-key="nombre_completo"
        >
          <template v-slot:item.asignados="{ item }">
            <v-btn
              rounded
              small
              color="primary"
              class="px-1 text-none"
              @click="Number(item.asignados) > 0 ? verDetalle(item, 'asignados') : null"
            >
              {{ item.asignados }}
            </v-btn>
          </template>

          <template v-slot:item.contestados="{ item }">
            <v-btn
              rounded
              small
              color="primary"
              class="px-1 text-none"
              @click="Number(item.contestados) > 0 ? verDetalle(item, 'contestados') : null"
            >
              {{ item.contestados }}
            </v-btn>
          </template>

          <template v-slot:item.cerrados="{ item }">
            <v-btn
              rounded
              small
              color="primary"
              class="px-1 text-none"
              @click="Number(item.cerrados) > 0 ? verDetalle(item, 'cerrados') : null"
            >
              {{ item.cerrados }}
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
        	color="black"
        	dark
        	tile
        	@click="reporteFechas.status = false"
        >Cancelar</v-btn>
      </v-card-actions>
    </v-card>

    <!-- Listado de tickets del conteo -->
    <v-dialog v-model="dialogDetalle" max-width="900" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">
          {{ tituloDetalle }}
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogDetalle = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersDetalle"
            :items="ticketsDetalle"
            class="elevation-0"
            dense
            :items-per-page="10"
            item-key="idticket"
          >
            <template v-slot:item.motivo="{ item }">
              <span class="text-caption">{{ resumenMotivo(item.motivo) }}</span>
            </template>

            <template v-slot:item.estatus="{ item }">
              <v-chip x-small dark :color="colorEstatus(item.estatus)">
                {{ textoEstatus(item.estatus) }}
              </v-chip>
            </template>

            <template v-slot:item.fecha="{ item }">
              <span class="text-caption">{{ fechaMostrar(item) }}</span>
            </template>

            <template v-slot:item.acciones="{ item }">
              <v-btn
                color="primary"
                small
                rounded
                @click="verContenidoTicket(item)"
              >
                Ver contenido
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" dark tile @click="dialogDetalle = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Contenido / historial del ticket -->
    <v-dialog v-model="dialogContenido" max-width="800" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">
          Folio: {{ ticketSeleccionado.idticket }}
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogContenido = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="mb-3 text-caption grey--text text--darken-1">
            <div v-if="ticketSeleccionado.plantel"><strong>Plantel:</strong> {{ ticketSeleccionado.plantel }}</div>
            <div v-if="ticketSeleccionado.tema"><strong>Tema:</strong> {{ ticketSeleccionado.tema }}</div>
            <div v-if="ticketSeleccionado.subtema"><strong>Subtema:</strong> {{ ticketSeleccionado.subtema }}</div>
            <div v-if="ticketSeleccionado.nombre_jefe"><strong>Jefe:</strong> {{ ticketSeleccionado.nombre_jefe }}</div>
            <div v-if="ticketSeleccionado.nombre_auxiliar"><strong>Auxiliar:</strong> {{ ticketSeleccionado.nombre_auxiliar }}</div>
          </div>

          <v-container v-for="(respuestas, i) in historial" :key="i" class="pa-0 mb-3">
            <v-row justify="space-between" dense>
              <v-col cols="6" class="pa-1">
                <strong class="text-caption">{{ i === 0 ? 'Motivo del ticket' : 'Seguimiento' }}</strong>
              </v-col>
              <v-col cols="6" class="pa-1 text-right text-caption">
                {{ respuestas.fecha }}
              </v-col>
            </v-row>

            <v-sheet class="pa-3 mb-2" color="grey lighten-4" rounded>
              <div class="text-body-2" style="white-space: pre-wrap;">{{ respuestas.motivo }}</div>
            </v-sheet>

            <template v-if="respuestas.respuesta">
              <v-row justify="end" dense>
                <v-col cols="12" class="pa-1 text-right text-caption">
                  Respondió: <strong>{{ respuestas.jefe || respuestas.auxiliar || '—' }}</strong>
                  <span v-if="respuestas.fecharespuesta"> · {{ respuestas.fecharespuesta }}</span>
                </v-col>
              </v-row>
              <v-sheet class="pa-3 mb-2" color="blue lighten-5" rounded>
                <div class="text-body-2" style="white-space: pre-wrap;">{{ respuestas.respuesta }}</div>
              </v-sheet>
            </template>

            <v-divider v-if="i < historial.length - 1" class="my-2"></v-divider>
          </v-container>

          <div v-if="!historial.length && !cargar" class="text-center grey--text py-4">
            Sin historial para este ticket
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" dark tile @click="dialogContenido = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
    <carga v-if="cargar"/>

  </v-dialog>
</template>
<script>
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue'
  import validarErrores        from '@/mixins/validarErrores'
  import { mapGetters }        from 'vuex'
  import funcionesExcel        from '@/mixins/funcionesExcel'

	export default {

		components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores, funcionesExcel ],

		props:[
			'reporteFechas',
	  ],

    computed: {
      ...mapGetters('login', ['getdatosUsuarioERPERP']),
      tituloDetalle () {
        const tipoLabel = {
          asignados: 'Asignados',
          contestados: 'Contestados',
          cerrados: 'Cerrados',
        }
        const tipo = tipoLabel[this.tipoDetalle] || ''
        const nombre = this.usuarioDetalle.nombre_completo || ''
        return `${tipo} · ${nombre}`
      },
    },

    data: () => ({
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      cargar: false,

      headersCerrados: [
        { text: 'Nombre',         value: 'nombre_completo' },
        { text: 'Asignados',      value: 'asignados'       },
        { text: 'Contestados',    value: 'contestados'     },
        { text: 'Cerrados',       value: 'cerrados'        },
      ],
      headersDetalle: [
        { text: 'Folio',     value: 'idticket', width: '80' },
        { text: 'Motivo',    value: 'motivo' },
        { text: 'Estatus',   value: 'estatus', width: '110' },
        { text: 'Fecha',     value: 'fecha', width: '140' },
        { text: '',          value: 'acciones', sortable: false, width: '130' },
      ],
      search:'',
      reporte: [],

      fechaini: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			fechafin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      dialogDetalle: false,
      dialogContenido: false,
      tipoDetalle: '',
      usuarioDetalle: {},
      ticketsDetalle: [],
      ticketSeleccionado: {},
      historial: [],
    }),

    created(){
			this.initialize()
		},

    methods:{

    	initialize( ){
    		let payload = {
    			fechaini: this.fechaini,
    			fechafin: this.fechafin,
    		}

				this.cargar  = true
        this.reporte = []

        this.$http.post('tickets.reporte.usuario.fecha', payload).then(response=>{
          this.reporte = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
    	},

      verDetalle (item, tipo) {
        if (!item || !Number(item[tipo])) return

        this.tipoDetalle = tipo
        this.usuarioDetalle = item
        this.ticketsDetalle = []
        this.dialogDetalle = true
        this.cargar = true

        const payload = {
          fechaini: this.fechaini,
          fechafin: this.fechafin,
          id_usuario: item.nombre_completo === 'Total' ? null : item.id_usuario,
          tipo,
        }

        this.$http.post('tickets.reporte.usuario.fecha.detalle', payload).then(response => {
          this.ticketsDetalle = Array.isArray(response.data) ? response.data : []
        }).catch(error => {
          this.validarError(
            (error.response && error.response.data && error.response.data.message)
              || 'Error al cargar el detalle'
          )
        }).finally(() => {
          this.cargar = false
        })
      },

      verContenidoTicket (item) {
        this.ticketSeleccionado = item || {}
        this.historial = []
        this.dialogContenido = true
        this.cargar = true

        this.$http.get('historial_tickets.estatus/' + item.idticket).then(response => {
          const lista = (response.data && response.data.HistorialTicket) || []
          this.historial = lista.map(h => ({
            ...h,
            fecha: this.formatearFecha(h.fecha),
            fecharespuesta: this.formatearFecha(h.fecharespuesta),
          }))
        }).catch(error => {
          this.validarError(
            (error.response && error.response.data && error.response.data.message)
              || 'Error al cargar el contenido del ticket'
          )
        }).finally(() => {
          this.cargar = false
        })
      },

      resumenMotivo (motivo) {
        const texto = String(motivo || '').trim()
        if (!texto) return '—'
        return texto.length > 120 ? texto.substring(0, 120) + '…' : texto
      },

      textoEstatus (estatus) {
        const map = {
          1: 'Nuevo',
          2: 'Asignado',
          3: 'Pendiente',
          4: 'Revisión',
          5: 'Respondido',
          6: 'Cerrado',
          7: 'Rechazado',
        }
        return map[Number(estatus)] || String(estatus || '—')
      },

      colorEstatus (estatus) {
        const map = {
          1: 'orange',
          2: 'blue',
          3: 'red',
          4: 'purple',
          5: 'green',
          6: 'teal',
          7: 'grey',
        }
        return map[Number(estatus)] || 'grey'
      },

      fechaMostrar (item) {
        if (this.tipoDetalle === 'cerrados') return this.formatearFecha(item.fecha_cierre)
        if (this.tipoDetalle === 'contestados') return this.formatearFecha(item.fecha_contestado)
        return this.formatearFecha(item.fecha_apertura)
      },

      formatearFecha (fecha) {
        if (!fecha || fecha === 'Invalid date') return '—'
        const d = new Date(fecha)
        if (Number.isNaN(d.getTime())) return String(fecha).substring(0, 19)
        const pad = n => String(n).padStart(2, '0')
        return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`
      },

      cerrar(){
      	this.reporteFechas.status = false
      	this.$emit('initialize')
      },
    }
	}
</script>
